import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";

/**
 * @description: this.$showModal
 * @author licheng |  licheng252@xdf.cn/lc822@outlook.com
 * @date 2019/12/17 12:12
 * ！！！！！ important
 * show 方法给外侧用./index.js 调用即显示
 * show方法传值
 *  @param {Component} 弹窗内容组件 这个组件需要写一个方法onOk(close),onCancel(close),点击footer的按钮时候会触发用回调close(传值)
 *  @param {comProps}  内容组件props
 *  @param {modalProps} 弹窗dialog的props   // 其中特殊的是 noFooter  不需要footer
 * ！！！！！ important
 * 不需要footer，自己触发关闭弹窗事件this.$attrs.close(传值)
 */
import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import CModal from './ShowModal.vue';
export default function showModal(_x) {
  return _showModal.apply(this, arguments);
} // 路由变化的时候得关闭所有弹窗，permission文件有处理

function _showModal() {
  _showModal = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(Component) {
    var compProps,
        modalProps,
        div,
        wrapper,
        modalIndex,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            compProps = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            modalProps = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};

            if (!window.modals) {
              window.modals = [];
            }

            if (!(window.modals.length >= 10)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", console.error('最多重叠十个弹窗！'));

          case 5:
            div = document.createElement('div');
            document.body.appendChild(div);
            wrapper = new Vue({
              el: div,
              store: store,
              router: router,
              render: function render(h) {
                return h(CModal);
              }
            });
            modalIndex = window.modals.length;
            window.modals.push(wrapper.$children[0]);
            modalProps.modalIndex = modalIndex;
            setTimeout(function () {
              // 防止闪烁，不能同步
              window.modals[modalIndex - 1] && window.modals[modalIndex - 1].setVisible(false);
            });
            return _context.abrupt("return", window.modals[modalIndex].show(Component, compProps, modalProps));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _showModal.apply(this, arguments);
}